module.exports = __webpack_public_path__ + "media/1fie-n-shkulat.a2bf2f85.mp3";